import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TableCellDescriptor } from '../../../../model.module/table-cell.model';
import { SortType } from '../../../../model.module/constant/sort-types.enum';
import { FilterFunctions } from '../../../../pipes.module/_filter.functions';
import { ConfirmationObservable } from '../../../../services.module/message.observable';
import { ConfirmModel } from '../../../../model.module/modals.model';
import { SuperComponent } from '../../../inside.super';
import { UserApiService } from '../../../../../generated/api/user/user.service';
import { AuthService } from '../../../../services.module/auth.service';
import { UserData } from '../../../../../generated/api/kreditportalBackendAPI.schemas';
import { HttpContext } from '@angular/common/http';
import { CACHE_OPTIONS, disableCache, enableCache } from '../../../../services.module/http-cache.tokens';

@Component({
    selector: 'benutzerverwaltung',
    templateUrl: './benutzerverwaltung.component.html',
    styleUrls: ['../../../commonless/content.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BenutzerverwaltungComponent extends SuperComponent implements OnInit, OnDestroy {

    task: string;

    currentOffset = 0;

    searchTerm = '';

    currUser: UserData[];
    visibleUser: UserData[];

    deleteUid: string;

    constructor(
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly confirmationHandler: ConfirmationObservable,
        private readonly userApiService: UserApiService,
        private readonly authService: AuthService
    ) {
        super();
    }

    userMetaData: TableCellDescriptor[] = [
        new TableCellDescriptor(
            'Name',
            'fullName',
            'value',
            true,
            SortType.ALPHABETICAL,
            '33%',
            true
        ),
        new TableCellDescriptor(
            'E-Mail-Adresse',
            'email',
            'value',
            true,
            SortType.ALPHABETICAL,
            '33%'
        ),
        new TableCellDescriptor(
            'Benutzer-ID',
            'uid',
            'value',
            true,
            SortType.NUMERICAL,
            '34%'
        )
    ];

    filterCellNames: string[] = ['fullName', 'email', 'uid'];

    ngOnInit() {
        this.loadList();

        this.activatedRoute.queryParams.subscribe((params: Params) => {
            const task = params['task'];

            if (task) {
                if ('refreshList' === task) {
                    this.reloadList();
                    this.task = null;
                } else {
                    this.task = task;
                }
            } else {
                this.task = null;
            }
        });
    }

    private reloadList() {
        setTimeout(() => this.loadList(true), 2000);
    }

    private loadList(refreshCache = false) {
        const vsnr = this.authService.getActiveKunde().vsnr;

        const context = new HttpContext().set(
            CACHE_OPTIONS,
            refreshCache ? disableCache() : enableCache()
        );

        this.userApiService.findUsersByVsnr(vsnr, { context })
            .subscribe(findUsersResponse => {
                // Tabelle, um Admins zu filtern
                const tempUser: UserData[] = [];

                for (const user of findUsersResponse.userDataList) {
                    if (user.userType.value !== 'KP_KU_ADMIN') {
                        tempUser.push(user);
                    }
                }

                this.currUser = tempUser;

                this.visibleUser = this.currUser;
            });
    }

    ngOnDestroy() {
        this.searchTerm = null;

        if (this.currUser) {
            this.currUser.forEach((bs) => bs = null);
            this.currUser = [];
        }
        if (this.visibleUser) {
            this.visibleUser.forEach((bs) => bs = null);
            this.visibleUser = [];
        }
    }

    notifyKeyup(): void {
        this.visibleUser = FilterFunctions.filterMatrix(this.currUser, this.filterCellNames, this.searchTerm);
    }

    searchMe = (term: string) => {
        this.visibleUser = FilterFunctions.filterMatrix(this.currUser, this.filterCellNames, term);
    };

    deleteAction = (uid: any): void => {
        for (const user of this.visibleUser) {
            if (user.uid.value !== uid.value) {
                continue;
            }

            this.deleteUid = uid.value;
            this.confirmationHandler.notify(new ConfirmModel(
                'Löschen',
                user.fullName.value + ' wirklich löschen?',
                [],
                this.deleteCallbackFunction,
                () => this.deleteUid = null
            ));
        }
    };

    deleteCallbackFunction = (): void => {
        const vsnr = this.authService.getActiveKunde().vsnr;
        const nutzerId = this.deleteUid;

        this.userApiService.starteNutzerLoeschen({ nutzerId, vsnr }).subscribe({
           next: () => {
               this.reloadList(); // Müssen wir machen wegen der Pagers (mehr als 12 Kunden).
               this.searchMe(this.searchTerm);
               this.deleteUid = null;
           },
           error: (err) => {
               console.error('Fehler beim Löschen des Nutzers:', err);
               this.deleteUid = null;
           }
        });
    };

    pagerAction = (page: number) => {
        this.currentOffset = page;
    };

    benutzerAnlegen(): void {
        this.router.navigate([], { queryParams: { task: 'benutzerAnlegen' } });
    }

}
